module.exports = __webpack_public_path__ + "img/icon-slide2.86bb9511.jpg";